import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { Box, Typography } from "@material-ui/core";
import "./styles.scss";
import {
  ActionButton,
  CloseButtonIcon,
  DesktopPopupModal,
  Icon,
  IconName,
  MobilePopoverCard,
  useDeviceTypes,
} from "halifax";
import {
  MODAL_ALERT_CHOICE,
  ModalAlertChoiceProperties,
  ModalButtonType,
  ModalCategoryType,
} from "redmond";
import clsx from "clsx";
import { ExperiencesInfoModalConnectorProps } from "./container";
import {
  EXPERIENCES_INFO_MODAL_POINTS,
  EXPERIENCES_INFO_MODAL_SUBHEADING_TEXT,
} from "./textConstants";
import {
  SEARCH_EXPERIENCES_BUTTON,
  getEarnMessageToDisplay,
} from "../../textConstants";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";

export interface IExperiencesInfoModalProps
  extends ExperiencesInfoModalConnectorProps,
    RouteComponentProps {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  isMobile?: boolean;
}

export const ExperiencesInfoModal = ({
  isOpen,
  setOpen,
  isMobile,
  largestValueAccount,
  fetchRewardsAccountsCallState,
}: IExperiencesInfoModalProps) => {
  const { matchesMobile } = useDeviceTypes();

  const onCloseHandler = (isPrimary: boolean) => {
    trackEvent({
      eventName: MODAL_ALERT_CHOICE,
      properties: {
        lob: "experiences",
        type: "experiences_info_awareness_modal",
        category: ModalCategoryType.FEATURE,
        primary_button: "search_experiences",
        funnel: "experiences",
        button_choice: isPrimary
          ? ModalButtonType.PRIMARY
          : ModalButtonType.CLOSE,
      } as ModalAlertChoiceProperties,
    });
    setOpen(false);
  };

  const ModalContent = React.useCallback(
    () => (
      <Box className="experiences-info-modal-content">
        <Box className="experiences-info-modal-header-content">
          <Icon name={IconName.CaponeTravelWhiteText} />
          <Box className="new-tag">New</Box>
          <Box className="experiences-info-modal-heading-container">
            <Typography
              variant="h3"
              className="experiences-info-modal-heading-text"
            >
              {getEarnMessageToDisplay(
                fetchRewardsAccountsCallState,
                largestValueAccount,
                false,
                false
              )}
            </Typography>
          </Box>

          <Typography className="experiences-info-modal-subheading-text">
            {EXPERIENCES_INFO_MODAL_SUBHEADING_TEXT()}
          </Typography>
        </Box>
        <Box className="experiences-info-modal-body-content">
          {EXPERIENCES_INFO_MODAL_POINTS.map(({ icon, text }) => (
            <Box key={icon} className="experiences-info-point">
              <Icon name={icon} className="experiences-info-point-icon" />
              <Typography className="experiences-info-point-text">
                {text}
              </Typography>
            </Box>
          ))}
          <ActionButton
            onClick={() => onCloseHandler(true)}
            className={clsx("search-experiences-button", {
              mobile: matchesMobile,
              desktop: !matchesMobile,
            })}
            // variant="b2b-shop-filter"
            message={SEARCH_EXPERIENCES_BUTTON}
          />
        </Box>
      </Box>
    ),
    [fetchRewardsAccountsCallState, largestValueAccount]
  );

  if (isMobile || matchesMobile)
    return (
      <MobilePopoverCard
        className="experiences-info-mobile-popover"
        open={isOpen}
        onClose={() => onCloseHandler(false)}
        topRightButton={
          <CloseButtonIcon onClick={() => onCloseHandler(false)} />
        }
      >
        <ModalContent />
      </MobilePopoverCard>
    );

  return (
    <DesktopPopupModal
      open={isOpen}
      className="experiences-info-modal"
      onClose={() => onCloseHandler(false)}
      invisibleBackdrop={false}
    >
      <ModalContent />
    </DesktopPopupModal>
  );
};
